import { IIntegrationPartner } from "../../../interfaces/interfaces";
import styles from "./MobileOTPContactMerito.module.scss";
import { ipShortNames } from "./emailOtpHelper";
import { BiWrench } from "react-icons/bi";

type Props = {
	selectedIp: IIntegrationPartner;
};

const MobileOTPContactMerito = ({ selectedIp }: Props) => {
	const shortIpName = ipShortNames[selectedIp?.companyName] ?? selectedIp?.companyName;

	// console.log("selectedIp", selectedIp);
	return (
		<>
			<div className={styles.statusScreen}>
				<div className={`${styles.info} ${styles.pending}`}>
					<BiWrench />
				</div>
				<h1>Contact Merito</h1>
				<p>{shortIpName} sends OTPs only to your mobile.</p>
				<p>
					To connect your account on Merito, set {shortIpName}
					<br />
					to send OTPs to your registered email.
				</p>
				<p>Contact Merito for assistance.</p>
			</div>
		</>
	);
};

export default MobileOTPContactMerito;
